import * as React from 'react';

export default class JobOfferLoader extends React.Component<{}, {}> {
  render() {
    return (
      <div className="profile-card-wrapper loader">
        <div className="profile-card-infos-wrapper">
          <div className="profile-card-image-container"></div>
          <div className="profile-card-infos-container">
            <div className="profile-card-name"></div>
            <div className="profile-card-fonction"></div>
            <div className="divider profile-card"></div>
            <div className="profile-card-socials-wrapper">
              <div className="link-block-socials w-inline-block">
                <i className="fas fa-circle fa-lg"></i>
              </div>
              <div className="link-block-socials w-inline-block">
                <i className="fas fa-circle fa-lg"></i>
              </div>
              <div className="link-block-socials w-inline-block">
                <i className="fas fa-circle fa-lg"></i>
              </div>
              <div className="link-block-socials w-inline-block">
                <i className="fas fa-circle fa-lg"></i>
              </div>
              <div className="link-block-socials w-inline-block">
                <i className="fas fa-circle fa-lg"></i>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className="profile-card-buttons-wrapper">
          <div className="profile-card-buttons-cotnainer">
            <div className="button solid left-cap grey w-inline-block mr-1 ml-0">
              <img
                src="/images/Cancel.svg"
                width="24"
                alt=""
                className="icon-button-profile-card"
              />
            </div>
            <div className="button solid right-cap grey w-inline-block ml-1 mr-0">
              <img
                src="/images/Cancel.svg"
                width="24"
                alt=""
                className="icon-button-profile-card"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
